import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import FounderMessage from './FounderMessage';

const managementTeam = [
  {
    id: 1,
    name: "Mary Wanjiru",
    position: "Director",
    imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczONcTo-XHkLdMdLlOEWaXX4xnoPwlvmgqyXvaHJZ0Q7f3rY43yg2Si9invEwP8XC2NK6IQc3H1q1zjkMTaOIGgcSQcO7V03StAhw9RoDiwVvB3mK_kn6jM_c1wsi3LMz5aF7GEV-eqB1MyfLScifw8h=w620-h827-s-no-gm?authuser=0"
  },
  {
    id: 2,
    name: "Mr. Patrick Ng'etich",
    position: "Principal",
    imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczMdW9l17qVQ6FlzZlklQ7hDipmYGJhUOgGuWiDMumKc1b2eeNub1oJ7EFMv4QosEYEicnRKsueqRij2K4fRYtjTxVAfvZ8phwtztcYN6edh9Xal2LnVoY2lDCRj6DmmIkvwDFqW8EkRcXP2YeNf4rvF=w1062-h816-s-no-gm?authuser=0"
  },
  {
    id: 3,
    name: "Mrs. Sarah Ngima",
    position: "Deputy Principal",
    imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczO8YGHIEk7NSAxin5tsLDyg2XnGlgo4Uajay33ay_QRPnLHuF6kH9lU9BTgYngbzTMDEJgfEmyXjjv92OoiZd2QjuNujBixvve_bPFsdyo5_etyivEGUfrdbO8A3s5BVl15juGQ02DZlUE7lUICzd9w=w1210-h798-s-no-gm?authuser=0"
  },
  {
    id: 4,
    name: "Mr. Francis Kamau",
    position: "Academics Officer",
    imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczOUQH53fu1D5ybhO2pHFqxcdA_jEoH2Lzk080QihSne-Bwac41JY12z2laH1QGp1hMBikkgBE5Su44JY11Fso3salBpqASzvXPyeBsVOA3R1673ktUvitjuHMHmf-PnNo_kPoxlqPv4xGZ_5L6-TZV7=w551-h827-s-no-gm?authuser=0"
  }
];

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

const AboutUs = () => {
  const [headerVisible, setHeaderVisible] = useState(false);
  const [cardsVisible, setCardsVisible] = useState(false);
  const [principalVisible, setPrincipalVisible] = useState(false);
  const [managementVisible, setManagementVisible] = useState(false);
  const sectionRef = useRef(null);

  /* ================= SEO WITHOUT INSTALLS ================= */
  useEffect(() => {
    document.title = "Anestar Boys Lanet – Victory Campus | About Us";

    const setMeta = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Anestar Boys Lanet – Victory Campus is a leading boys school in Lanet, Nakuru under the Anestar Group of Schools, committed to academic excellence, strong values, and holistic education."
    );

    setMeta(
      "keywords",
      "Anestar Boys Lanet, Anestar Victory Campus, Anestar Boys Lanet Victory Campus, Anestar Group of Schools, Boys School in Lanet Nakuru"
    );
  }, []);
  /* ======================================================== */

  useEffect(() => {
    const timer1 = setTimeout(() => setHeaderVisible(true), 100);
    const timer2 = setTimeout(() => setCardsVisible(true), 300);
    const timer3 = setTimeout(() => setPrincipalVisible(true), 500);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setManagementVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="bg-background-light dark:bg-background-dark font-display text-slate-800 dark:text-slate-200 relative overflow-hidden">
      <main className="relative z-10">
        <div className="mx-auto max-w-6xl px-4 py-12">

          {/* ================= HEADER ================= */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            animate={headerVisible ? "visible" : "hidden"}
            className="text-center"
          >
            <h1 className="text-3xl font-bold text-primary sm:text-4xl">
              Anestar Boys Lanet – Victory Campus
            </h1>

            <h2 className="mt-2 text-xl font-semibold">
              About Us
            </h2>

            <p className="mt-4 text-lg text-slate-600 dark:text-slate-400">
              Anestar Boys Lanet – Victory Campus is a distinguished institution
              under the Anestar Group of Schools, dedicated to nurturing academic
              excellence, discipline, leadership, and Christ-centered values
              for boys in Lanet, Nakuru.
            </p>
          </motion.div>

          {/* ================= VISION / CORE VALUES / MISSION ================= */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            animate={cardsVisible ? "visible" : "hidden"}
            className="mt-12 rounded-lg bg-white p-6 shadow-md dark:bg-slate-800"
          >
            <h3 className="text-2xl font-bold text-primary mb-4">
              Vision, Core Values & Mission
            </h3>

            {/* Vision */}
            <div className="p-4 bg-primary/5 rounded-lg border-l-4 border-primary mb-4">
              <p><strong>Vision:</strong> Preparing globally competitive citizens grounded in values, vision, and innovation.</p>
            </div>

            {/* Core Values */}
            <div className="p-4 bg-gold/5 rounded-lg border-l-4 border-gold mb-4">
              <p><strong>Core Values:</strong></p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li><strong>CH</strong> - Christ Centeredness</li>
                <li><strong>I</strong> - Integrity</li>
                <li><strong>C</strong> - Compassion</li>
                <li><strong>H</strong> - Hard Work</li>
                <li><strong>E</strong> - Excellence</li>
                <li><strong>M</strong> - Men of Valor</li>
              </ul>
            </div>

            {/* Mission */}
            <div className="p-4 bg-primary/5 rounded-lg border-l-4 border-primary">
              <p>
                <strong>Mission:</strong> To provide world-class education in a safe,
                caring environment while nurturing academic excellence, strong moral
                values, and holistic growth.
              </p>
            </div>
          </motion.div>

          {/* ================= FOUNDER ================= */}
          <div className="mt-10">
            <FounderMessage />
          </div>

          {/* ================= DEPUTY PRINCIPAL ================= */}
          <motion.section
            variants={fadeInUp}
            initial="hidden"
            animate={principalVisible ? "visible" : "hidden"}
            className="mt-16 rounded-lg bg-white dark:bg-slate-800 p-8 shadow-md"
          >
            <h3 className="text-2xl font-bold text-primary text-center mb-6">
              Deputy Principal’s Message
            </h3>

            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Image */}
              <div className="relative h-48 w-48 rounded-full overflow-hidden mx-auto md:mx-0">
                <div
                  className="h-full w-full rounded-full bg-cover bg-center shadow-md"
                  style={{ backgroundImage: `url(${managementTeam[2].imageUrl})` }}
                />
                <div className="absolute inset-0 rounded-full border-4 border-primary/20"></div>
              </div>

              {/* Message */}
              <div className="text-center md:text-left flex-1">
                <p className="text-xl font-bold text-slate-900 dark:text-white">
                  {managementTeam[2].name}
                </p>
                <p className="text-md text-primary font-semibold">{managementTeam[2].position}</p>
                <p className="mt-4 italic text-slate-700 dark:text-slate-300 leading-relaxed">
                  “At Anestar Boys Lanet – Victory Campus, we believe learning extends beyond the classroom. We nurture curiosity, discipline, and character, preparing boys for life, leadership, and service.”
                </p>
              </div>
            </div>
          </motion.section>

          {/* ================= MANAGEMENT TEAM ================= */}
          <motion.div
            ref={sectionRef}
            variants={fadeInUp}
            initial="hidden"
            animate={managementVisible ? "visible" : "hidden"}
            className="mt-16"
          >
            <h3 className="text-center text-3xl font-bold">
              Management & Faculty – Anestar Boys Lanet Victory Campus
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-8">
              {managementTeam.map((member, idx) => (
                <motion.div
                  key={member.id}
                  variants={{
                    hidden: { opacity: 0, y: 20 },
                    visible: { opacity: 1, y: 0, transition: { delay: idx * 0.2, duration: 0.6 } }
                  }}
                  initial="hidden"
                  animate={managementVisible ? "visible" : "hidden"}
                  whileHover={{ scale: 1.05 }}
                  className="text-center"
                >
                  {/* Hidden SEO Image */}
                  <img
                    src={member.imageUrl}
                    alt={`${member.name} – Anestar Boys Lanet Victory Campus ${member.position}`}
                    className="hidden"
                  />

                  <div
                    className="h-32 w-32 mx-auto rounded-full bg-cover bg-center shadow-md"
                    style={{ backgroundImage: `url(${member.imageUrl})` }}
                  />
                  <p className="mt-4 font-semibold">{member.name}</p>
                  <p className="text-primary text-sm">{member.position}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

        </div>
      </main>
    </div>
  );
};

export default AboutUs;
